import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentTypeService {


  url = environment.serverAPI5 + "/api/paymentType"; 
  
  constructor(private http: HttpClient,
    private loginService:LoginService) { }

  getAllPaymentMode(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllPaymentModeDropDown(): Observable<Object> {
    
    let authourized = this.loginService.getAuthenticatedUser();
    if(authourized){
      return this.http.get(`${this.url}/dropdown`);
    }else{
      return this.http.get(`${this.url}/ig/dropdown`);
    }

  }


  getPaymentModeById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditPaymentMode(paymentMode: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, paymentMode);
  }

  paymentModeSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  syncPayMentMode() {
    return this.http.get(`${this.url}/sync`);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }


}
